import React from 'react';
import { cx } from '@emotion/css';

type Props = {
  styles: any;
  serrviceList: Array<{ name: string }>;
  customLabel?: string;
  customHeadings?: any;
  customFooter?: any;
};
export const ListOfServices = (props: Props) => {
  const {
    serrviceList,
    styles,
    customLabel = 'List of Services',
    customHeadings = '',
    customFooter = '',
  } = props;

  return (
    <section className={styles.list_of_services}>
      <div className={styles.container}>
        <div className={styles.root}>
          <h3 className={cx(styles.site_title, styles.h3)}>{customLabel}</h3>
          {customHeadings ? (
            <CustomHeading styles={styles} headings={customHeadings} />
          ) : null}
          <ul className={styles.services_list}>
            {serrviceList.map((service, index) => (
              <li key={index} className={styles.service_tags}>
                <a href="#" className={styles.tags_link}>
                  {service.name}
                </a>
              </li>
            ))}
          </ul>

          {customFooter ? (
            <CustomFooter styles={styles} footer={customFooter} />
          ) : null}
        </div>
      </div>
    </section>
  );
};

const CustomHeading = ({ styles, headings }: any) => {
  return (
    <div className={styles.site_sub_title_container}>
      <p className={cx(styles.site_sub_title, styles.p)}> {headings} </p>
    </div>
  );
};

const CustomFooter = ({ styles, footer }: any) => {
  return (
    <div className={styles.site_sub_title_container}>
      <p className={cx(styles.site_sub_title, styles.p)}> {footer} </p>
    </div>
  );
};
